import { NumberInput } from "../../number-input";
import { Select } from "../../select";
import { event } from "../../../Foundation";

export class ProductDropdownEventListeners {
    constructor(elem, _refs) {
        this.elem = elem;
        this._refs = {..._refs};
    }

    /**
     * Create and add new dropdown fields
     * @param {String} attrValue 
     */
    createNewDropdownField(attrValue, data) {
        const resetDataField = () => {
            cloneElement.dataset.old_field_id = '';
            cloneElement.dataset.field_id = '';
            cloneElement.dataset.value = '0';
        }

        const resetQuantity = (cloneElementNumberInput) => {
            cloneElementNumberInput.querySelector('.number-input__field').setAttribute('value', 0);
        }

        const resetSelectedItem = (cloneElementSelect) => {
            const selectedFirstItem = cloneElementSelect.querySelector('option');
            const isSelected = cloneElementSelect.querySelector('option[selected]');
            isSelected.removeAttribute('selected');
            selectedFirstItem.setAttribute('selected', true);
            // IMPORTANT: remove custom select field
            cloneElement.querySelector('.form-select__el').remove();
        }

        const resetDropdown = () => {
            const cloneElementSelect = cloneElement.querySelector('[data-select]');
            const cloneElementNumberInput = cloneElement.querySelector('.number-input');
            // Update select element to display selected options
            cloneElement.querySelector('[data-select]').innerHTML = elementSelect;
            resetSelectedItem(cloneElementSelect);
            resetQuantity(cloneElementNumberInput);
            resetDataField();
            
            // Create new custom select field
            new Select(cloneElementSelect);
            new NumberInput(cloneElementNumberInput);
        }

        const elementSelect = this.elem.querySelector(`[data-item="${attrValue}"] [data-select]`).innerHTML;
        const cloneElement = data.cloneElement.cloneNode(true);
        resetDropdown();
        
        // Append watch element
        this.watchSelectField(cloneElement);
        this.watchQuantityField(cloneElement);
        // Append new dropdown field
        const contentSide = this.elem.querySelector(`[data-item="${attrValue}"] .item_wrapper`);
        contentSide.append(cloneElement);

        // Apply filter on new dropdown
        this.triggerFilterUpdate();
    } 

    triggerFilterUpdate() {
        const filterElements = Array.from(this.elem.parentElement.querySelectorAll('.configurator__accessories-item'));
        for(let item of filterElements) {
            // Add change to the items to trigger MutationObserver
            item.classList.add('update');
            item.classList.remove('update');
        }
    }

    cloneTemplateItem() {
        for(let item of this._refs.data) {
            const itemElem = this.elem.querySelector(`[data-item="${item.attrValues}"] .configurator__accessories-item`);
            const cloneElem = itemElem.cloneNode(true);
            item.cloneElement = cloneElem;
        }
    }

    /**
     * Triggers
     */
    watchEvents() {
        const itemElemts = Array.from(this.elem.querySelectorAll('.configurator__dropdown .configurator__accessories-item'));
        const buttonElemts = Array.from(this.elem.querySelectorAll('.addAccessoryDropdown'));
        const filterElements = Array.from(this.elem.parentElement.querySelectorAll('.configurator__accessories-item'));

        for(let elem of itemElemts) {
            this.watchDropdownField(elem);
        }

        if(!this._refs.bundle) {
            for(let btn of buttonElemts) {
                this.watchAddMoreButton(btn);
            }
        }

        for(let elem of filterElements) {
            this.watchFilterChanges(elem, this._refs.config);
        }

        this.cloneTemplateItem();
    }

    watchDropdownField(elem) {
        const selectedID = elem.querySelector('select')?.value;
        elem.setAttribute('data-old_field_id', selectedID);
        elem.setAttribute('data-field_id', selectedID);
        this.watchSelectField(elem);
        this.watchQuantityField(elem);
    }

    watchSelectField(elem) {
        const selectField = elem.querySelector('select');
        selectField?.addEventListener('change', () => {
            elem.setAttribute('data-old_field_id', elem.getAttribute('data-field_id'))
            elem.setAttribute('data-field_id', selectField.value);
            this.setDefaultQuantity(elem, selectField);
            this.updateFields(elem, selectField);
            this.updateHiddenFields(elem, selectField);
            this.updateImage(elem, selectField);
            this.validateAddMoreFields();
        })
    }

    /**
     * Watch and update quantity field (If not bundle)
     * @param {Element} elem 
     */
    watchQuantityField(elem) {
        const quantityInput = elem.querySelector('input[type=text]');
        const selectField = elem.querySelector('select');
        quantityInput?.addEventListener('change', () => {
            elem.setAttribute('data-value', quantityInput.value);
            this.updateFields(elem, quantityInput);
            this.updateHiddenFields(elem, quantityInput);
            // Check if fields needs to be removed / reset
            if(selectField?.value && quantityInput.value < 1) {
                this.removeOrResetItem(elem);
                this.validateAddMoreFields();
            }
        })
    }

    watchAddMoreButton(btn) {
        btn.addEventListener('click', () => {
            const btnSide = btn.getAttribute('data-item');
            const contentSide = this._refs.data.filter(obj => obj.attrValues.toLowerCase() === btnSide);
            this.createNewDropdownField(btnSide, contentSide[0]);
            this.validateAddMoreFields();
        })
    }

    watchFilterChanges(elem, config) {
        const observer = new MutationObserver((mutationList) => {
            this.toggleFilterItems(this._refs.elem, mutationList)
        });
        observer.observe(elem, config);
    }

    removeOrResetItem(elem) {
        const itemWrapper = elem.closest('.item_wrapper');
        const items = [...itemWrapper.querySelectorAll('.configurator__accessories-item')];
        // reset items
        const firstOption = elem.querySelector('.form-select__list-item > div');
        firstOption.click();
        // remove item if wrapper contains more than one item
        if(items.length > 1) {
            elem.remove()
        }
    }

    /**
     * Show/Hide dropdown option based of filter
     * @param {Element} contentElem 
     * @param {Array} mutationList 
     */
    toggleFilterItems(contentElem, mutationList) {
        for(let mutation of mutationList) {
            if (mutation.type === 'attributes') {
                const isHiddenItem = mutation.target.classList.contains('is-hidden')
                const targetText = mutation.target.querySelector('.configurator__accessory-title')?.innerText;
                const contentOptions = Array.from(contentElem.querySelectorAll('.form-select__list-item'));
                const targetOptions = contentOptions.filter(elem => elem.querySelector('.form-select__list-label').innerText === targetText);
                if(targetOptions.length > 0) {
                    for(let option of targetOptions) {
                        if(isHiddenItem) {
                            option.classList.add('is-hidden');
                        } else {
                            option.classList.remove('is-hidden');
                        }
                    }
                }
            }
        }
    }

    /**
     * Validate if number of dropdowns <= options
     * (Logic to prevent user from adding infinit dropdown)
     * @returns 
     */
    validateAddMoreFields() {
        if(!this._refs.data) return;
        const disabledButton = (itemElems, obj, checkEmptyValueFields) => {
            // Deactivate if number of dropdown is equal to the available options
            const maxFields = itemElems.length === obj.length;
            // Deactivate if it is bundle
            const isBundle = obj.bundle;
            // Deactivate if one or more fields are empty
            const emptyFields = checkEmptyValueFields.length > 0;
            return maxFields || isBundle || emptyFields;
        }

        const optionLength = this._refs.data.map(item => {
            return {
                "item":item.attrValues, 
                "length":item.data[0].length,
                "bundle":item.isBundle
            }
        });
        for(let obj of optionLength) {
            const itemElems = Array.from(this.elem.querySelectorAll(`.configurator__dropdown [data-item="${obj.item}"] .configurator__accessories-item`));
            const checkEmptyValueFields = itemElems.filter(el => !el.querySelector('select').value);
            this.activateAddMoreButton(obj.item)
            // Check if button should be disabled
            const isDisabled = disabledButton(itemElems, obj, checkEmptyValueFields);
            if(isDisabled) {
                this.deactivateAddMoreButton(obj.item)
            }
        }
    }

    activateAddMoreButton(item) {
        const button = this.elem ?.querySelector(`.addAccessoryDropdown[data-item="${item}"]`);
        button?.removeAttribute('disabled');
    }
    deactivateAddMoreButton(item) {
        const button = this.elem ?.querySelector(`.addAccessoryDropdown[data-item="${item}"]`);
        button?.setAttribute('disabled', '');
    }

    setDefaultQuantity(item, elem) {
        const targetId = item.getAttribute('data-field_id').trim();
        const newValue = item.getAttribute('data-value');

        if(targetId.length === 0) return;
        // Set default value
        if(newValue !== '0') return;
        this.toggleDefaultValue(true, item);
    }

    updateFields(item, elem) {
        const disableSelectedOptions = () => {
            if(!targetId) return;
            const options = Array.from(this.elem.querySelectorAll(`.form-select option[value=${targetId}]`));
            let optionText = '';
            for(let option of options) {
                option.setAttribute('disabled', '');
                optionText = option.innerText;
            }
            toggleSelectStyling(optionText);
        }
        const enableSelectedOptions = () => {
            if(oldTargetId === targetId || !oldTargetId) return;
            const options = Array.from(this.elem.querySelectorAll(`.form-select option[value=${oldTargetId}]`));
            let optionText = '';
            for(let option of options) {
                option.removeAttribute('disabled');
                optionText = option.innerText;
            }
            toggleSelectStyling(optionText);
        }
        /**
         * Apply / remove highlight from selected items
         * @param {String} optionText 
         * @returns 
         */
        const toggleSelectStyling = (optionText) => {
            const itemParent = elem.closest('.form-select');
            if(!itemParent) return;
            const itemLabelElement = Array.from(itemParent.querySelectorAll('.form-select__list-item .form-select__list-label'))
            .filter(el =>  el.innerText === optionText);
            if(itemLabelElement.length <= 0) return;
            const itemElement = itemLabelElement[0]?.closest('.form-select__list-item');
            itemElement.classList.toggle('selected');
        }

        /**
         * 
         * @returns Reset quantity field
         */
        const resetQuantityField = () => {
            if(targetId.length === 0) {
                this.toggleDefaultValue(false, item);
            };
        }

        const targetId = item.getAttribute('data-field_id');
        const oldTargetId = item.getAttribute('data-old_field_id');
        
        disableSelectedOptions();
        enableSelectedOptions();
        resetQuantityField();
    }

    toggleDefaultValue(setting, item) {
        const toggleButtons = () => {
            if(setting) {
                minusButton.classList.remove('is-disabled');
                plusButton.classList.remove('is-disabled');
                return
            }
            minusButton.classList.add('is-disabled');
            plusButton.classList.add('is-disabled');
        }
        const setDefaultValue = () => {
            item.setAttribute('data-value', defaultValue);
            quantityField.value = defaultValue;
        }
        const quantityField = item.querySelector('.number-input__field');
        const minusButton = item.querySelector('.number-input__button--minus');
        const plusButton = item.querySelector('.number-input__button--plus');
        let defaultValue = 0;
        if(setting) {
            defaultValue = 1;
        }
        if(!quantityField) return;
        setDefaultValue();
        toggleButtons();
    }

    updateHiddenFields(item, elem) { 
        const updateHiddenControllers = () => {
            if(targetId) {
                if(this._refs.bundle) {
                    document.querySelector(`#${targetId}`).setAttribute('checked', '');
                    document.querySelector(`#${targetId}`).checked = true;
                } else {
                    document.querySelector(`#${targetId}`).value = newValue;
                }
            }

            for(let select of allSelector) {
                event.emit(select, 'reflow');
            }
        }
        const resetHiddenControllers = () => {
            if(oldTargetId && oldTargetId !== 'null') {
                if(this._refs.bundle) {
                    document.querySelector(`#${oldTargetId}`).removeAttribute('checked');
                    document.querySelector(`#${oldTargetId}`).checked = false;
                } else {
                    if(oldTargetId === targetId) return;
                    document.querySelector(`#${oldTargetId}`).value = 0;
                }
            }
        }

        const allSelector = Array.from(this.elem.querySelectorAll(`.form-select select`));
        const targetId = item.getAttribute('data-field_id');
        const oldTargetId = item.getAttribute('data-old_field_id');
        const newValue = item.getAttribute('data-value');

        updateHiddenControllers();
        resetHiddenControllers();
    }

    updateImage(item, elem) {
        const setDefaultImage = () => {
            const dataGroup = elem.getAttribute('data-item');
            const groupData = this._refs.data.filter(group => group.attrValues === dataGroup);
            if(groupData.length === 0) return;
            const deafultImage = groupData[0].image;
            setImageSource(elem, deafultImage);
        };
        const setImageSource = (el, source) => {
            const elemInner = el.closest('.configurator__accessory-inner');
            const elemImage = elemInner.querySelector('img');
            elemImage.src = source;
        }
        const getImageSource = (el) => {
            const elemInner = el.closest('.configurator__accessory-inner');
            const elemImage = elemInner.querySelector('img');
            const elemImageSource = elemImage.src;
            return elemImageSource;
        }
        // Set deafult image
        if(!item.dataset.field_id) {
            setDefaultImage();
            return;
        };
        // Set new image
        const hiddenField = document.querySelector(`#${item.dataset.field_id}`);
        if(!hiddenField) return;
        const hiddenFieldImageSource = getImageSource(hiddenField);
        const contentImageSource = getImageSource(elem);

        if(hiddenFieldImageSource === contentImageSource) return;
        setImageSource(elem, hiddenFieldImageSource);
    }
}